// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"01b5add2","513":"ec840dbd","703":"93b9d886","787":"50f62f8e"}[chunkId] + ".chunk.js";
};